'use client';

import { ReactNode } from 'react';
import useTinuitiPixel from '@alltrails/core/hooks/marketingTracking/useTinuitiPixel';
import useWeatherPixel from '@alltrails/core/hooks/marketingTracking/useWeatherPixel';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import useCaptureSessionAttribution from '@alltrails/session-storage/hooks/useCaptureSessionAttribution';
import ReturningUserUpsell from '@alltrails/upsell/components/ReturningUserUpsell/ReturningUserUpsell';
import UpsellContentLoader from '@alltrails/upsell/components/UpsellContentLoader/UpsellContentLoader';
import AppleRedirectUpsell from '@alltrails/user-auth/components/AppleRedirectUpsell/AppleRedirectUpsell';
import useAppleRedirectHandler from '@alltrails/user-auth/hooks/useAppleRedirectHandler';
import useBraze from '../hooks/useBraze';
import useOsano from '../hooks/useOsano';
import AmplitudeBrowserSdk from '../scripts/AmplitudeBrowserSdk';
import GoogleOneTap from './GoogleOneTap';
import MinimalHeader from './MinimalHeader';

type PageProps = {
  children: ReactNode;
  disableInAppMessages?: boolean;
  hideGoogleOneTap?: boolean;
  hideAppleRedirectUpsell?: boolean;
  hideReturningUserUpsell?: boolean;
  hideHeaderOnMobile?: boolean;
  mainClassName?: string;
  pageViewLimitReached?: boolean;
  showStandardLogo?: boolean;
};

const MinimalHeaderPage = ({
  children,
  disableInAppMessages,
  hideGoogleOneTap = false,
  hideAppleRedirectUpsell = false,
  hideReturningUserUpsell = false,
  hideHeaderOnMobile = false,
  mainClassName,
  pageViewLimitReached,
  showStandardLogo
}: PageProps) => {
  useOsano();
  useTinuitiPixel();
  useWeatherPixel();
  useBraze({ disableInAppMessages });
  useAppleRedirectHandler();
  useCaptureSessionAttribution();
  const isMobile = useIsMobileSizedScreen();
  const hideHeader = hideHeaderOnMobile && isMobile;

  return (
    <>
      <AmplitudeBrowserSdk />
      <UpsellContentLoader />
      {!hideGoogleOneTap && <GoogleOneTap pageViewLimitReached={pageViewLimitReached} />}
      {!hideHeader && <MinimalHeader showStandardLogo={showStandardLogo} />}
      <main className={mainClassName} role="main">
        {children}
        {!hideReturningUserUpsell && <ReturningUserUpsell />}
        {!hideAppleRedirectUpsell && <AppleRedirectUpsell />}
      </main>
    </>
  );
};

export default MinimalHeaderPage;
